
export const prices = {
  title: "Tarifs 2026-2027",
  monthlyFees: {
    title: "Frais Mensuels",
    subtitle: "10 paiements/an · Inclut l'enseignement et le matériel",
    tableHeaders: {
      level: "Niveau",
      firstChild: "1er enfant",
      secondChild: "2ème enfant",
      thirdChild: "3ème enfant"
    },
    infantil: {
      title: "MATERNELLE",
      ageRange: "3 à 5 ans",
      schedule: "8h45 à 14h00"
    },
    primaryC1: {
      title: "PRIMAIRE C1",
      ageRange: "6 à 8 ans",
      schedule: "8h45 à 14h00"
    },
    primaryC2: {
      title: "PRIMAIRE C2",
      ageRange: "9 à 11 ans",
      schedule: "8h45 à 14h00"
    }
  },
  enrollment: {
    title: "Frais d'Inscription",
    description: "Les frais d'inscription comprennent la réservation de place, la gestion administrative et l'évaluation initiale",
    renewal: {
      title: "Renouvellement (familles actuelles)",
      subtitle: "Inscription annuelle pour confirmer la place",
      price: "350€",
      note: "Identique pour tous les frères et sœurs"
    },
    newStudents: {
      title: "Nouveaux Élèves",
      subtitle: "Inscription première année",
      firstChild: {
        title: "Premier enfant",
        price: "700€"
      },
      siblings: {
        title: "2ème et 3ème enfant",
        price: "350€"
      }
    }
  },
  specialDiscounts: {
    title: "Réductions Spéciales",
    earlyEnrollment: {
      title: "Inscription Anticipée",
      description: "Effectuez votre inscription avant le 23 février et économisez 50€ par enfant",
      badge: "-50€"
    },
    annualPayment: {
      title: "Paiement Annuel",
      description: "Payez l'année complète à l'avance et obtenez 200€ de réduction + 200€ en bon pour anniversaires ou camps",
      badges: {
        discount: "-200€",
        voucher: "+200€ bon"
      }
    }
  },
  discounts: {
    title: "Réductions Fratrie",
    description: "Réductions appliquées automatiquement aux frais mensuels",
    secondChild: {
      title: "Deuxième enfant",
      description: "20% de réduction sur les frais mensuels"
    },
    thirdChild: {
      title: "Troisième enfant et suivants",
      description: "40% de réduction sur les frais mensuels"
    }
  },
  additionalServices: {
    title: "Services Supplémentaires",
    transport: {
      title: "Taxi depuis Vigo",
      description: "Taxi depuis Vigo. Minimum de 4 places. Seul ce service exige un engagement de réservation pour tout le trimestre ; le tarif indiqué est mensuel.",
      roundTrip: {
        title: "Aller-retour",
        price: "225€/mois"
      }
    },
    earlyBirds: {
      title: "Accueil Matinal",
      monthly: {
        title: "Mensuel",
        price: "75 €"
      },
      daily: {
        title: "Journée unique",
        price: "7€"
      },
      description: "Service quotidien à partir de 8h15"
    },
    food: {
      title: "Cantine",
      monthly: {
        title: "5 jours/semaine",
        price: "195€"
      },
      threeDays: {
        title: "3 jours/semaine",
        price: "125€"
      },
      twoDays: {
        title: "2 jours/semaine",
        price: "90€"
      },
      daily: {
        title: "Journée unique",
        price: "15€"
      },
      description: "Menu élaboré par un nutritionniste avec des produits biologiques Les forfaits cantine sont réservés et payés chaque mois. Choisissez 5, 3 ou 2 jours fixes par semaine. Ludothèque incluse jusqu’à 17h00 (vendredi jusqu’à 16h00). Journée ponctuelle : prévenir 48 heures à l’avance.",
      takeaway: {
        title: "Repas à emporter",
        description: "Pour le même prix, vous pouvez également commander des repas à récupérer à tout moment entre 14h00 et 17h00. Les contenants sont fournis par Gándara."
      }
    },
    ludoteca: {
      title: "Ludothèque",
      schedule: "Horaires: 15h00 à 17h00 (vendredi jusqu'à 16h00)",
      freeService: "Gratuit avec déjeuner ou extrascolaires",
      dayPass: {
        title: "Jour isolé"
      },
      oneDay: {
        title: "Un jour/semaine"
      },
      twoDays: {
        title: "Deux jours/semaine"
      },
      fiveDays: {
        title: "Cinq jours/semaine"
      },
      description: "Service de garde et d'activités après les heures d'école"
    }
  },
  preEnrollment: {
    title: "Prêt(e) à franchir le prochain pas ?",
    subtitle: "Rejoignez notre communauté éducative en 3 étapes simples",
    steps: "Préinscription → Visite guidée → Inscription",
    ctaPrimary: "Demander une Préinscription",
    ctaSecondary: "Réserver une Visite",
    note: "Le formulaire de préinscription n'implique aucun engagement"
  }
};
